import { render } from "./AppCopyright.vue?vue&type=template&id=5d60a738&scoped=true"
import script from "./AppCopyright.vue?vue&type=script&lang=js"
export * from "./AppCopyright.vue?vue&type=script&lang=js"

import "./AppCopyright.vue?vue&type=style&index=0&id=5d60a738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d60a738"]])

export default __exports__